/*eslint-disable*/
import React from "react";

const footerText = process.env.REACT_APP_FOOTER_TEXT || '';

export default function Footer() {
  return (
    <div className="mx-auto flex w-full max-w-screen-sm flex-col items-center justify-center px-[20px] pb-4 lg:max-w-[100%] lg:flex-row xl:w-[1310px] xl:pb-6">
      <p className="mb-0 text-center text-sm text-white opacity-20 md:text-md">
        {/* custom text */}
        © {new Date().getFullYear()} {footerText}
      </p>
    </div>
  );
}
